import React, { useState } from 'react';

const ProfilePage = ({
  username,
  setCurrentPage,
  fetchUserData,
  avatarUrl,
  clickCount,
  clickPower,
  income,
  energy,
  maxEnergy,
  triggerToast,
  setSelectedClan,
  clan_id,
  userId,
  rank,
  inventory,
  clan,
}) => {
  const [inputPromoCode, setInputPromoCode] = useState('');
  const [isInventoryOpen, setIsInventoryOpen] = useState(false); // Открыт ли инвентарь

  // Использование промокода
  const usePromoCode = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/promos/use`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, promoCode: inputPromoCode }),
      });

      const data = await response.json();
      if (response.ok) {
        triggerToast('Промокод активирован.');
        await fetchUserData(username);
      } else {
        triggerToast(data.message || 'Ошибка использования промокода.');
      }
    } catch (error) {
      console.error('Ошибка при использовании промокода:', error);
      triggerToast('Ошибка при использовании промокода.');
    }
  };

  return (
    <div className="container_">
      <div className="profile-header">
        <div className="user-avatar">
          <img src={avatarUrl || 'default-avatar.png'} alt="User Avatar" />
        </div>
        <div className="profile-details">
          <h1 className="profile-username">{username}</h1>
          <div className="rank-container">
            {rank && (
              <>
                <p className="profile-rank" style={{ color: rank.text_color }}>
                {rank.name.length > 10 ? rank.name.slice(0, 7) + '...' : rank.name}
                </p>
                <img
                  src={rank.image || rank.image_url || 'default-rank.png'}
                  alt={`${rank.name} Rank`}
                  className="rank-image"
                />
              </>
            )}
          </div>
        </div>
      </div>


      <div className="clan-section">
        {clan ? (
          <div className="clan-info">
            <p>Ваш клан:</p>
            <h3>{clan.name}</h3>
            <div className="clan-actions">
              <button
                className="clan-button"
                onClick={() => {
                  setSelectedClan(clan_id);
                  setCurrentPage('clans_info');
                }}
              >
                Перейти в клан
              </button>
              <button className="icon-button" onClick={() => setCurrentPage('clans')}>
                <img src="/assets/imgur/1Q9Dv2v.png" alt="Планета" className="icon" />
              </button>
            </div>
          </div>
        ) : (
          <div className="clan-info">
            <p>Вы не в клане</p>
            <div className="clan-actions">
            <button className="clan-button" onClick={() => setCurrentPage('clans')}>
              Найти клан
            </button>
            <button className="icon-button" onClick={() => setCurrentPage('clan_list')}>
                <img src="/assets/imgur/1Q9Dv2v.png" alt="Планета" className="icon" />
              </button>
              </div>
          </div>
        )}
      </div>

      <button className="achievements-btn" onClick={() => setCurrentPage('achievements')}>
          Достижения
        </button>
        <button
  className="achievements-btn"
  onClick={() => setIsInventoryOpen((prev) => !prev)} // Тоггл состояния
>
  {isInventoryOpen ? 'Скрыть инвентарь' : 'Показать инвентарь'}
</button>

{isInventoryOpen && (
  <div className="inventory-container">
    <h3 className="inventory-title">Ваш инвентарь</h3>
    {inventory.length > 0 ? (
      <ul className="inventory-list">
      {inventory.map((item) => (
        <li key={item.item_id} className="inventory-item">
          <img 
            src={item.image_url || 'default-item.png'} 
            alt={item.name} 
            style={{ width: '80px', height: '80px' }} 
          />
          <div className="item-details">
            <p className="item-name">{item.name}</p>
            <p className="item-click-power">Сила клика: +{item.click_power}</p>
            <p className={`item-rarity rarity-${item.rarity.toLowerCase()}`}>{item.rarity}</p>
          </div>
        </li>
      ))}
    </ul>
    
    ) : (
      <p>Ваш инвентарь пуст.</p>
    )}
  </div>
)}




        
<div className="promo-section">
        <input
          type="text"
          placeholder="Введите промокод"
          value={inputPromoCode}
          onChange={(e) => setInputPromoCode(e.target.value)}
          className="promo-input"
        />
        <button onClick={usePromoCode} className="promo-btn">
          ✓
        </button>
      </div>

  {/* Статистика */}
  <div className="user-stats">
        <h3>👀 Ваша статистика</h3>
        <div className="stats-grid">
          <div className="stats-item-left">
            <span className="stats-label">Количество кликов:</span>
            <span className="stats-value">{clickCount}</span>
          </div>
          <div className="stats-item-right">
            <span className="stats-label">Апгрейдов клика:</span>
            <span className="stats-value">{clickPower}</span>
          </div>
          <div className="stats-item-left">
            <span className="stats-label">Заработок за 24 часа:</span>
            <span className="stats-value">{income}</span>
          </div>
          <div className="stats-item-right">
            <span className="stats-label">Прокачек дохода:</span>
            <span className="stats-value">{income / 100}</span>
          </div>
          <div className="stats-item-left">
            <span className="stats-label">Максимальная энергия:</span>
            <span className="stats-value">{maxEnergy}</span>
          </div>
          <div className="stats-item-right">
            <span className="stats-label">Текущая энергия:</span>
            <span className="stats-value">{energy}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
